// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.j4eq20LTUo4emCg8DVE0{align-items:center;gap:4px;padding:4px;display:flex}.MZXxCQBAqB82FpRLR8El{background:var(--border-neutral-primary);width:1px;height:16px;margin-left:2px;margin-right:2px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `j4eq20LTUo4emCg8DVE0`,
	"divider": `MZXxCQBAqB82FpRLR8El`
};
export default ___CSS_LOADER_EXPORT___;
